module.exports = (parcelRequire.load("5LZhG")).then(() => parcelRequire('i7S3f'));